
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare-movers",
      function () {
        return require("private-next-pages/medicare-movers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare-movers"])
      });
    }
  